/*
 *
 * PayByLinkTutorialPopup
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 27-Mar-2025
*/

import React from 'react'
import PropTypes from 'prop-types'
import MerchantModal from '@nexidigital/merchantmodal'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import { useNavigate } from 'react-router-dom'
import './PayByLinkTutorialPopup.scss'

const PayByLinkTutorialPopup = (props) => {
  const navigate = useNavigate()

  return (
    <Toggle>
      <MerchantModal
        ariaModalDescription=''
        ariaModalTitle=''
        title={formattedMessage.tutorialPopupTitle}
        onClose={() => props.actions.doHidePopup()}
        primaryAction={() => {
          props.actions.doEvents({ marketingType: 'PAYMAIL', event: 'START' })
          props.actions.doHidePopup()
          navigate('/services/pay-by-link/store-selection')
        }}
        primaryButtonLabel={formattedMessage.tutorialPopupButtonLabel}
      >
        <ol className='pblPopupList'>
          <li className='pblPopupNumberedList'>{formattedMessage.tutorialPopupCopyFirstPoint}</li>
          <li className='pblPopupNumberedList'>{formattedMessage.tutorialPopupCopySecondPoint}</li>
          <li className='pblPopupNumberedList'>{formattedMessage.tutorialPopupCopyThirdPoint}</li>
        </ol>
      </MerchantModal>
    </Toggle>
  )
}

PayByLinkTutorialPopup.propTypes = {
  actions: PropTypes.object.isRequired
}

PayByLinkTutorialPopup.defaultProps = {
  actions: {}
}

export default PayByLinkTutorialPopup
